import * as types from "./types";
import {
    getBankAxios, 
    getBankIDAxios,
    deleteBankAxios,
    postBankAxios,
    putBankAxios
} from "./services";

export async function getBankListAction({commit}) {
    commit(types.LOADING_BANK, true);
    try {
        const {data} = await getBankAxios();
        commit(types.GET_BANK_LIST, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_BANK, false);
    }
   
}

export async function getBankIDAction({commit},payload) {
    commit(types.LOADING_BANK, true);
    try {
        const {data} = await getBankIDAxios(payload);
        commit(types.GET_BANK_ID, data.result);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_BANK, false);
    }
}

export async function removeBankAction({commit}, payload) {
    commit(types.LOADING_BANK, true);
    try {
        await deleteBankAxios(payload);
        commit(types.REMOVE_BANK, payload);
    }
    catch(e) {
       
        throw e;
    }
    finally {
        commit(types.LOADING_BANK, false);
    }
}

export async function addBankAction({ commit }, payload) {
    commit(types.LOADING_BANK, true);
    try {
      const { data } = await postBankAxios(payload);
      payload.id = data.result.id;
      commit(types.ADD_BANK, payload);
    } catch (e) {
   
      throw e;
    } finally {
      commit(types.LOADING_BANK, false);
    }
  }

  export async function updateBankAction({ commit }, payload) {
    commit(types.LOADING_BANK, true);
    try {
      await putBankAxios(payload);
      commit(types.UPDATE_BANK, payload);
    } catch (e) {
  
      throw e;
    } finally {
      commit(types.LOADING_BANK, false);
    }
  }
